import React from "react";
import axios from "axios";
const BASE_URL = "https://fh905bgax2.execute-api.ap-south-1.amazonaws.com/testing";


export const getStationWiseData= async (station, start_date, end_date,page_size, lastEvaluatedKey) => {
  try {
    // const myInit = {
    //   headers: {
    //     "Content-Type": "application/json"
    //   }
    // };
    const response = await axios.get(`${BASE_URL}/stationwise-data`,{
      params: { 
        station: station,
        start_date:  start_date,
        end_date: end_date,
        page_size: page_size,
        last_evaluated_key: lastEvaluatedKey
    }});
    console.log(response.data.body);
    return response.data.body;
  } catch (error) {
    throw error;
  }
}; 


export const getDashboardData = async (station) => {
  try {
  
    const response = await axios.get(`${BASE_URL}/dashboard-data`,
    {
      params:{
        station : station
      }
    })
   //console.log(response.data.body);
    return response.data.body;
  }
  catch(err){
    console.log(err)
  }
}
